import UsersHeader from 'components/users/UsersHeader'
import UsersList from 'components/users/UsersList'
import AnimatedSpan from 'containers/animatedSpan/AnimatedSpan';
import useWindowSize from './../hooks/useWindowSize';
import React,{ useState, useEffect } from 'react'
import {isAdmin} from 'utils/Constants';
import {Navigate} from 'react-router-dom';

const Users = () => {
    const [listType, setListType] = useState(1)
	const [createUser, setCreateUser] = useState(false)
  const {width} = useWindowSize();
	const [filterOptions, setFilterOptions] = useState({ searchText:'' })
    
  useEffect(()=>{
    if(width < 936){
      setListType(2)
    } else {
      setListType(1)
    }
  },[width])
if (!isAdmin) {
  return <Navigate to='/projects' />
}

  return (
    <AnimatedSpan className='users page-container'>
        <UsersHeader filterOptions={filterOptions} setFilterOptions={ setFilterOptions} createUser={createUser} setCreateUser={setCreateUser} listType={listType} setListType={setListType}/>
        <UsersList filterOptions={filterOptions} setFilterOptions={ setFilterOptions} createUser={createUser} listType={listType}/>
    </AnimatedSpan>
  )
}

export default Users